import React, {FC, useState} from 'react';
import {Helmet} from 'react-helmet';
import {Location} from '@reach/router';
import {HelmetHeaderProps} from '../types';
import {graphql, useStaticQuery} from 'gatsby';

export default ({}: FC<HelmetHeaderProps>) => {
  const data = null;

  const current = '';

  const workflowsList = '';

  const [headerData] = useState<{title: string; path: string; description?: string; image?: string}[]>([
    {
      title: 'Customer support contacts | Hexomatic',
      description: 'Customer support contacts - content change detection and alerting solution',
      path: '/contact',
    },
    {
      title: 'Software Integrations',
      description: 'List of 3rd party integrations with Hexomatic',
      path: '/software-integrations',
    },
    {
      title: 'Get workflow monitoring notifications in Telegram',
      description: 'Connect with Telegram to receive the monitoring notifications about your workflows.',
      path: '/telegrambot',
    },
    {
      title: 'Get workflow monitoring notifications in Slack',
      description: 'Connect with Slack to receive the monitoring notifications about your workflows.',
      path: '/slackbot',
    },
    {
      title: 'Get workflow monitoring notifications in Discord',
      description: 'Connect with Discord to receive the monitoring notifications about your workflows.',
      path: '/discord',
    },
    {
      title: 'Import, export or synchronize data in your workflow via Google Sheets.',
      description: 'Connect with Google to import, export or synchronize data in your workflow.',
      path: '/google-sheets',
    },
    {
      title: 'Hexomatic Integration with Zapier',
      description: 'Connect with Zapier to receive the monitoring notifications about your workflows.',
      path: '/zapier',
    },
    {
      title: 'Hexomatic Integration with Pabbly Connect',
      description: 'Integrate Pabbly Connect to receive the monitoring notifications about your workflows.',
      path: '/pabbly-connect',
    },
    {
      title: 'Hexomatic Integration with Microsoft Teams',
      description: 'Connect with Microsoft Teams to receive the monitoring notifications about your workflows.',
      path: '/microsoft-teams',
    },
    {
      title: 'Hexomatic Integration with KonnectzIT',
      description: 'Connect with KonnectzIT to receive the monitoring notifications about your workflows.',
      path: '/konnectzit',
    },
    {
      title: 'Hexomatic Integration with Make, formerly Integromat',
      description: 'Connect with Make to receive the monitoring notifications about your workflows.',
      path: '/make',
    },
    {
      title: 'Hexomatic Integration with Integrately',
      description: 'Connect with Integrately to receive the monitoring notifications about your workflows.',
      path: '/integrately',
    },
    {
      title: 'Integrate Google with Hexomatic | Hexomatic',
      description: 'Connect your Google account to Hexomatic. ',
      path: '/google',
    },
    {
      title: 'Connect webhook URL to your account | Hexomatic',
      description: 'Connect webhook URL to your account and get JSON formatted data of the workflow. ',
      path: '/webhook',
    },
    {
      title: 'Post in WordPress at scale | Hexomatic',
      description:
        'Post in WordPress at scale from any data source from your workflow with our Hexomatic WordPress automation.',
      path: '/wordpress',
    },
    {
      title: 'Get data from any SQL database inside your workflow | Hexomatic',
      description: 'Tap into SQL databases from your own applications inside Hexomatic to access data at scale.',
      path: '/sql-database',
    },
    {
      title: 'Export or sync your data to Google Drive | Hexomatic',
      description: 'Hexomatic lets you save any file from your workflow to your Google Drive account on autopilot.',
      path: '/google-drive',
    },
    {
      title: 'Import data via Google Sheets | Hexomatic',
      description:
        'Hexomatic lets you use Google sheets right inside your workflow as an input for scraping receipts or automations.',
      path: '/google-sheets-import',
    },
    {
      title: 'Export and synchronize data in your workflow via Google Sheets | Hexomatic',
      description: 'Hexomatic enables you to automatically export or synchronize your data to Google Sheets.',
      path: '/google-sheets-export-sync',
    },
    {
      title: 'Cookie Policy | Hexomatic',
      description: 'This Cookie Policy describes how and why HEXACT use cookies',
      path: '/cookie-policy',
    },
    {
      title: 'FAQ | Hexomatic',
      description:
        'Do you have any questions regarding Hexomatic services and tools? Find answers on all your questions or contact us.',
      path: '/faq',
    },
    {
      title: 'Pricing Packages | Hexomatic',
      description:
        'See all the benefits of our pricing packages and get the best for you. Hexomatic allows you to chose either free, or paid plans.',
      path: '/pricing',
    },
    {
      title: 'API Documentation',
      description: 'This page provides API documentation for workflows',
      path: '/api-documentation',
    },
    {
      title: 'Discover Tech Stack API documentation',
      description: 'This page provides API documentation for Discover Tech Stack',
      path: '/automation/discover-tech-stack/api-documentation',
    },
    {
      title: 'Screenshot capture API documentation',
      description: 'This page provides API documentation for Screenshot capture',
      path: '/automation/create-screenshot/api-documentation',
    },
    {
      title: 'Discover WHOIS API documentation',
      description: 'This page provides API documentation for Discover WHOIS',
      path: '/automation/discover-whois/api-documentation',
    },
    {
      title: 'Discover Profile API documentation',
      description: 'This page provides API documentation for Discover Profile',
      path: '/automation/discover-profile/api-documentation',
    },
    {
      title: 'Privacy Policy | Hexomatic',
      description:
        'Your privacy is very important to us and we have created this privacy statement in order to demonstrate our commitment to you.',
      path: '/privacy-policy',
    },
    {
      title: 'Hexomatic - reset password',
      description: '',
      path: '/reset-password',
    },
    {
      title: 'Hexomatic Public Roadmap | Development Plans',
      description:
        "We are excited to announce our Hexomatic roadmap! This is a place for you to see what's coming next and how any feedback from users like yourself can help shape it.",
      path: '/roadmap',
    },
    {
      title: 'About Hexomatic | How Hexomatic Works',
      description:
        'Hexomatic is a no-code, work automation platform that enables you to use the internet as your own data source, leverage the most complex AI services to automate and delegate time consuming tasks.',
      path: '/about',
    },
    {
      title: 'Hexomatic Use Cases | Growth Hacking Use Cases',
      description:
        'See growth hacking use cases with Hexomatic. Find automated solutions for your e-commerce business, sales and marketing teams, finance or investment  research teams.',
      path: '/use-cases',
    },
    {
      title: 'Meet the Hexomatic team',
      description:
        'The ones who see things differently, working tirelessly behind the scenes so you can change the world.',
      path: '/meet-the-team',
    },
    {
      title: 'Growth hacking playbook',
      description: '',
      path: '/get-our-growth-hacking-playbook',
    },
    {
      title: '90+ Automations to run sales, marketing & research tasks',
      description:
        'Tap into the true power of the cloud with 1-click access to data, analysis, research, and AI-powered automation services. Create the perfect workflow in minutes',
      path: '/automations',
    },
    {
      title: 'Terms of Service | Hexomatic',
      description:
        'These Terms of Service contain an Arbitration Agreement that may impact your rights to use the courts to resolve disputes.',
      path: '/terms-of-use',
    },
    {
      title: '',
      description: '',
      path: '/home',
    },
    {
      title: '',
      description: '',
      path: '/404',
    },
    {
      title: 'Web Scraping and Workflow Automation Made Easy | Hexomatic',
      description:
        'Tap into the internet as your own data source with our web scraper and automate 90+ sales, marketing, or research tasks on autopilot.',
      path: '/',
    },
    {
      title: 'Hexomatic – GDPR',
      // description: 'Register your free account and get full access to the website tools.',
      path: '/gdpr',
    },
    {
      title: 'Hexomatic – Choose your plan',
      // description: 'Register your free account and get full access to the website tools.',
      path: '/checkout',
    },
    {
      title: 'Media Kit | Hexomatic logo and colors',
      description:
        'We share guidelines to help our customers use Hexomatic logo and colors without having to negotiate legal agreements',
      path: '/media-kit',
    },
    {
      title: 'Become a Hexomatic affiliate partner',
      description: 'Become a Hexomatic affiliate partner and earn 20% commission on every sale and renewal.',
      path: '/affiliate',
    },
    {
      title: 'Premium credits',
      description: 'Premium credit add-on',
      path: '/premium-credits',
    },
    //tools
    {
      title: 'Growth hacking automation tools - Hexomatic',
      description:
        'Find contact details, perform tech stack analysis or tap into AI services with our easy-to-use growth hacking tools, powered by Hexomatic.',
      path: '/tools',
    },
    {
      title: 'Online Text to Speech Generator | Realistic AI Voice',
      description:
        "Hexomatic's online text to speech converter turns any text into the most natural-sounding speech and allows you to save it to .mp3 format. 40+ languages available",
      path: '/tools/text-to-speech',
    },
    {
      title: 'Tech Stack Checker | Free Tech Stack Analyzer',
      description:
        "Find out any website technology stack and perform instant tech stack checks  in minutes! Automate your website's competitors analysis.",
      path: '/tools/tech-stack-analyzer',
    },
    {
      title: 'Whois domain lookup | Free Domain Whois Lookup',
      description:
        'Use our whois domain lookup tool to discover domain expiry, ownership, contact, registrar, and nameserver information for any domain or IP.',
      path: '/tools/whois-domain-lookup',
    },
    {
      title: 'Grammar and Spell Checker | Hexomatic',
      description:
        "Use Hexomatic's grammar and spell checker for any web page! This tool allows you to catch typos, spelling, and grammar mistakes in seconds.",
      path: '/tools/grammar-spell-checker',
    },
    {
      title: 'QR code generator | Free tool',
      description:
        'Generate QR codes in seconds and use it on stationary, posters, merchandise or product packaging. This will also benefit to drive traffic and increase sales',
      path: '/tools/qr-code-generator',
    },
    {
      title: 'Word Count Checker | Web Page Content Checker Tool',
      description:
        "Explore Hexomatic's word count checker tool, find any web page keywords and keywords' count, see the average reading time of the page for free",
      path: '/tools/word-count',
    },
    {
      title: 'Screen Capture | Multi Device Website Screenshot Capture',
      description: 'Our free online tool will provide you with screenshot captures for any device screen size.',
      path: '/tools/screenshot-capture',
    },
    {
      title: 'Accessibility Audit | Free Website Accessibility Audit',
      description:
        'Perform any page accessibility audit in seconds. Get recommendations for making the web more accessible to people with disabilities.',
      path: '/tools/accessibility-audit',
    },
    //Automation category
    {
      title: 'Automations/Scraping',
      description: 'Scraping automations',
      path: '/automations/scraping',
    },
    {
      title: 'Automations/Notifications',
      description: 'Notifications automations',
      path: '/automations/notifications',
    },
    {
      title: 'Automations/Data-transformations',
      description: 'Data transformations automations',
      path: '/automations/data-transformations',
    },
    {
      title: 'Automations/SEO',
      description: 'SEO automations',
      path: '/automations/seo',
    },
    {
      title: 'Automations/Research',
      description: 'Research automations',
      path: '/automations/research',
    },
    {
      title: 'Automations/Actions',
      description: 'Actions automations',
      path: '/automations/actions',
    },
    {
      title: 'Automations/Integrations',
      description: 'Integrations automations',
      path: '/automations/integrations',
    },
    {
      title: 'Automations/Translation',
      description: 'Translation automations',
      path: '/automations/translation',
    },
    {
      title: 'Automations/Validation',
      description: 'Validation automations',
      path: '/automations/validation',
    },
    {
      title: 'Automations/Audits',
      description: 'Audits automations',
      path: '/automations/audits',
    },
    {
      title: 'Automations/AI services',
      description: 'AI services automations',
      path: '/automations/ai-services',
    },

    //Automation types
    {
      title: 'Automations/Premium automations',
      description: 'Premium automations',
      path: '/automations/premium-automations',
    },
    {
      title: 'Automations/Crowdsourced automations',
      description: 'Crowdsourced automations',
      path: '/automations/crowdsourced-automations',
    },
    {
      title: 'Built-in Automations | Hexomatic',
      description:
        'Find out your preferred built-in automation in Hexomatic. We offer wide variety of built-in automations for your business.',
      path: '/automations/built-in-automations',
    },

    //Automation combined type/category

    ///Premium-automations
    {
      title: 'Automations/Premium automations/Scraping',
      description: 'Premium automations - Scraping',
      path: '/automations/premium-automations/scraping',
    },
    {
      title: 'Automations/Premium automations/Notifications',
      description: 'Premium automations - Notifications',
      path: '/automations/premium-automations/notifications',
    },
    {
      title: 'Automations/Premium automations/Data transformations',
      description: 'Premium automations - Data transformations',
      path: '/automations/premium-automations/data-transformations',
    },
    {
      title: 'Automations/Premium automations/SEO',
      description: 'Premium automations - SEO',
      path: '/automations/premium-automations/seo',
    },
    {
      title: 'Automations/Premium automations/Research',
      description: 'Premium automations - Research',
      path: '/automations/premium-automations/research',
    },
    {
      title: 'Automations/Premium automations/Actions',
      description: 'Premium automations - Actions',
      path: '/automations/premium-automations/actions',
    },
    {
      title: 'Automations/Premium automations/Integrations',
      description: 'Premium automations - Integrations',
      path: '/automations/premium-automations/integrations',
    },
    {
      title: 'Automations/Premium automations/Translation',
      description: 'Premium automations - Translation',
      path: '/automations/premium-automations/translation',
    },
    {
      title: 'Automations/Premium automations/Validation',
      description: 'Premium automations - Validation',
      path: '/automations/premium-automations/validation',
    },
    {
      title: 'Automations/Premium automations/Audits',
      description: 'Premium automations - Audits',
      path: '/automations/premium-automations/audits',
    },
    {
      title: 'Automations/Premium automations/AI services',
      description: 'Premium automations - AI services',
      path: '/automations/premium-automations/ai-services',
    },
    {
      title: 'Automations/Premium automations/SEO',
      description: 'Premium automations - SEO',
      path: '/automations/premium-automations/seo',
    },
    ///Cowdsourced-automations
    {
      title: 'Automations/Crowdsourced automations/Scraping',
      description: 'Crowdsourced automations - Scraping',
      path: '/automations/crowdsourced-automations/scraping',
    },
    {
      title: 'Automations/Crowdsourced automations/Notifications',
      description: 'Crowdsourced automations - Notifications',
      path: '/automations/crowdsourced-automations/notifications',
    },
    {
      title: 'Automations/Crowdsourced automations/Data transformations',
      description: 'Crowdsourced automations - Data transformations',
      path: '/automations/crowdsourced-automations/data-transformations',
    },
    {
      title: 'Automations/Crowdsourced automations/SEO',
      description: 'Crowdsourced automations - SEO',
      path: '/automations/crowdsourced-automations/seo',
    },
    {
      title: 'Automations/Crowdsourced automations/Research',
      description: 'Crowdsourced automations - Research',
      path: '/automations/crowdsourced-automations/research',
    },
    {
      title: 'Automations/Crowdsourced automations/Actions',
      description: 'Crowdsourced automations - Actions',
      path: '/automations/crowdsourced-automations/actions',
    },
    {
      title: 'Automations/Crowdsourced automations/Integrations',
      description: 'Crowdsourced automations - Integrations',
      path: '/automations/crowdsourced-automations/integrations',
    },
    {
      title: 'Automations/Crowdsourced automations/Translation',
      description: 'Crowdsourced automations - Translation',
      path: '/automations/crowdsourced-automations/translation',
    },
    {
      title: 'Automations/Crowdsourced automations/Validation',
      description: 'Crowdsourced automations - Validation',
      path: '/automations/crowdsourced-automations/validation',
    },
    {
      title: 'Automations/Crowdsourced automations/Audits',
      description: 'Crowdsourced automations - Audits',
      path: '/automations/crowdsourced-automations/audits',
    },
    {
      title: 'Automations/Crowdsourced automations/AI services',
      description: 'Crowdsourced automations - AI services',
      path: '/automations/crowdsourced-automations/ai-services',
    },
    {
      title: 'Automations/Crowdsourced automations/SEO',
      description: 'Crowdsourced automations - SEO',
      path: '/automations/crowdsourced-automations/seo',
    },

    ///Built-in automations
    {
      title: 'Automations/Built-in automations/Scraping',
      description: 'Automations - Built-in automations - Scraping',
      path: '/automations/built-in-automations/scraping',
    },
    {
      title: 'Automations/Built-in automations/Notifications',
      description: 'Automations - Built-in automations - Notifications',
      path: '/automations/built-in-automations/notifications',
    },
    {
      title: 'Automations/Built-in automations/Data transformations',
      description: 'Automations - Built-in automations - Data transformations',
      path: '/automations/built-in-automations/data-transformations',
    },
    {
      title: 'Automations/Built-in automations/SEO',
      description: 'Automations - Built-in automations - SEO',
      path: '/automations/built-in-automations/seo',
    },
    {
      title: 'Automations/Built-in automations/Research',
      description: 'Automations - Built-in automations - Research',
      path: '/automations/built-in-automations/research',
    },
    {
      title: 'Automations/Built-in automations/Actions',
      description: 'Automations - Built-in automations - Actions',
      path: '/automations/built-in-automations/actions',
    },
    {
      title: 'Automations/Built-in automations/Integrations',
      description: 'Automations - Built-in automations - Integrations',
      path: '/automations/built-in-automations/integrations',
    },
    {
      title: 'Automations/Built-in automations/Translation',
      description: 'Automations - Built-in automations - Translation',
      path: '/automations/built-in-automations/translation',
    },
    {
      title: 'Automations/Built-in automations/Validation',
      description: 'Automations - Built-in automations - Validation',
      path: '/automations/built-in-automations/validation',
    },
    {
      title: 'Automations/Built-in automations/Audits',
      description: 'Automations Built-in automations Audits',
      path: '/automations/built-in-automations/audits',
    },
    {
      title: 'Automations/Built-in automations/AI services',
      description: 'Automations - Built-in automations - AI services',
      path: '/automations/built-in-automations/ai-services',
    },
    {
      title: 'Automations/Built-in automations/SEO',
      description: 'Automations - Built-in automations - SEO',
      path: '/automations/built-in-automations/seo',
    },

    //Public workflows
    {
      title: 'Ready Made Workflow Templates | Hexomatic',
      description:
        'Deploy entire automation strategies in minutes to find new leads, perform website audits, reverse engineer SEO strategies or save hours of manual work in a few click.',
      path: '/ready-made-workflow-library',
    },
    {
      title:
        'Page 2/3 - Workflow library - Ready made templates to automate sales, marketing and research tasks | Hexomatic',
      description: '',
      path: '/ready-made-workflow-library?page=2',
    },
    {
      title:
        'Page 3/3 - Workflow library - Ready made templates to automate sales, marketing and research tasks | Hexomatic',
      description: '',
      path: '/ready-made-workflow-library?page=3',
    },

    {
      title: 'Ready made workflows for Sales teams',
      description:
        'Simplify and scale your sales prospecting with our ready-made workflow templates designed for sales teams. Tap into complex multi-step strategies featuring Google search, Google Maps, and Yelp to find fresh prospects and enrich your data in minutes.',
      path: '/ready-made-workflow-library/sales',
    },
    {
      title: 'Ready made workflows for Research teams',
      description:
        'Perform research and data gathering tasks at scale with our ready-made workflow templates designed for research and data analysis teams. Run audits, extract data, perform analysis, and leverage state-of-the-art AI for image labeling and OCR.',
      path: '/ready-made-workflow-library/research',
    },
    {
      title: 'Ready made workflows for Marketing teams',
      description:
        'Automate and scale time-consuming marketing and SEO strategies with our ready-made workflow templates. Deploy entire marketing strategies featuring SEO data, machine translation, spelling audits, accessibility checks, and more in minutes.',
      path: '/ready-made-workflow-library/marketing',
    },
    {
      title: 'Ready made workflows for Marketing teams',
      description:
        'Automate and scale time-consuming marketing and SEO strategies with our ready-made workflow templates. Deploy entire marketing strategies featuring SEO data, machine translation, spelling audits, accessibility checks, and more in minutes.',
      path: '/ready-made-workflow-library/marketing?page=2',
    },
  ]);

  const generateHeaderMenuItem = () => {
    const headers = [...headerData];

    current &&
      current.map((item: any) => {
        item &&
          headers.push({
            title: item.meta_title,
            path: `/automation/${item.url}`,
            description: item.meta_title,
          });
      });

    const getCleanPath = (name: string) => {
      const singleWorkflowPath = name.toLowerCase();
      const cleanPath = singleWorkflowPath.replace(/ /g, '-');
      return `/ready-made-workflow-library/${cleanPath}`;
    };

    workflowsList &&
      workflowsList.map((item: any) => {
        item &&
          headers.push({
            title: item.meta_title,
            path: getCleanPath(item.name),
            description: item.description,
            image: item.image,
          });
      });
    return headers;
  };

  return (
    <Location>
      {({location}) => {
        const item = generateHeaderMenuItem().find((data: any) => {
          if (location.pathname[location.pathname.length - 1] === '/' && location.pathname !== '/') {
            return data.path === location.pathname.substr(0, location.pathname.length - 1);
          } else if (location.pathname === '/') {
            return data.path === location.pathname;
          } else if (data.path === '/get-our-growth-hacking-playbook' && location.pathname.includes(data.path)) {
            return data;
          } else {
            return location.pathname === data.path || location.pathname === data.path + '/';
          }
        });
        return (
          item && (
            <Helmet key={item.title} title={item.title}>
              <html lang="en" />
              <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
              <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
              <link rel="icon" type="image/png" sizes="192x192" href="/android-chrome-192x192.png" />
              <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
              {/* <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#03b8ff" /> */}
              <link rel="canonical" href={`https://hexomatic.com${location.pathname}`} />
              <meta name="msapplication-TileColor" content="#03b8ff" />
              <meta name="msapplication-TileImage" content="/mstile-144x144.png" />
              <meta name="theme-color" content="#ffffff" />
              <meta name="msapplication-config" content="/browserconfig.xml" />

              <meta name="description" content={item.description} />
              <meta property="og:type" content="website" />
              <meta property="og:image" content={item.image || 'https://hexomatic.com/Home-page-illustrations.jpg'} />
              <meta property="og:url" content={`https://hexomatic.com${location.pathname}`} />
              <meta property="og:title" content={item.title} />
              <meta property="og:description" content={item.description} />
              <meta property="og:locale" content={'en_US'} />
              <meta name="twitter:image" content={item.image || 'https://hexomatic.com/Home-page-illustrations.jpg'} />
              <meta name="twitter:title" content={item.title} />
              <meta name="twitter:description" content={item.description} />
              <meta name="twitter:card" content={'summary_large_image'} />
              <meta name="twitter:site" content={'@hexactinc'} />
            </Helmet>
          )
        );
      }}
    </Location>
  );
};
